import { useMaintenanceProjectsRPC, type MaintenanceFilters } from './useMaintenanceProjectsRPC';

/**
 * Hook for fetching maintenance projects (status = 'service')
 * Uses dedicated maintenance RPC that only returns service projects
 */
export const useMaintenanceProjectsQuery = (
  filters: MaintenanceFilters, 
  page: number = 1, 
  pageSize: number = 50
) => {
  return useMaintenanceProjectsRPC(filters, page, pageSize);
};